import {
  type GetSessionsAnalyticsActivityArgs,
  useLazyGetSessionsAnalyticsActivityQuery,
} from '@carboncopyco/data';
import type { Resolution } from '@carboncopyco/types';
import {
  getDateFromDaysAgo,
  getNowInFormat,
  getTimezoneName,
  useTourAnalytics,
} from '@carboncopyco/utils';
import { useEffect, useMemo, useState } from 'react';
import { SingleBarChart, useGetActivityChartConfig } from '../../Charts';
import { useDashboardProps } from '../DashboardContext';

export const TourActivityChart = () => {
  const { trackTourSelectTimeFilter } = useTourAnalytics({
    location: 'analytics_page',
  });
  const { organizationId, selectedWorkspaceIds, timeRange, short, internal } =
    useDashboardProps();
  const [resolution, setResolution] = useState<Resolution>('day');

  const fetchArgs: GetSessionsAnalyticsActivityArgs = useMemo(
    () => ({
      organizationId,
      shortSessions: short,
      internalSessions: internal,
      workspaceIds: selectedWorkspaceIds,
      start: getDateFromDaysAgo(timeRange),
      end: getNowInFormat('YYYY-MM-DDTHH:mm:ssZ'),
      timezone: getTimezoneName(),
      resolution,
      resourceTypes: ['tour'],
    }),
    [
      organizationId,
      short,
      internal,
      selectedWorkspaceIds,
      timeRange,
      resolution,
    ]
  );

  const [getManagedPresentationOverTimeChart, { data, isFetching, isError }] =
    useLazyGetSessionsAnalyticsActivityQuery();

  useEffect(() => {
    getManagedPresentationOverTimeChart(fetchArgs);
  }, [fetchArgs]);

  const chartData = useGetActivityChartConfig(data, 'tour', timeRange);
  const isEmpty = !data?.results.length;

  useEffect(() => {
    if (timeRange === '7') {
      setResolution('day');
    }
  }, [timeRange]);

  return (
    <SingleBarChart
      timePeriod={timeRange}
      isLoading={isFetching}
      isError={isError}
      isEmpty={isEmpty}
      chartData={chartData}
      resolution={resolution}
      setResolution={setResolution}
      chartHeight={310}
      trackEvent={() =>
        trackTourSelectTimeFilter({
          period: timeRange,
          resolution,
        })
      }
    />
  );
};
